import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AddedStudentsList from "../components/AddedStudentsList";
import citiesPortuguese from "../util/cities-pt";
import languageEnum from "../util/enums";
import statesPortuguese from "../util/states-pt";

export function Accident({ token }) {
  const { t, i18n } = useTranslation("global");
  const [occurrenceDate, setOccurrenceDate] = useState("");
  const [occurrenceTime, setOccurrenceTime] = useState("");
  const [placeState, setPlaceState] = useState("");
  const [placeCity, setPlaceCity] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [schoolType, setSchoolType] = useState("");
  const [problemType, setProblemType] = useState("");
  const [problemPlace, setProblemPlace] = useState("");
  const [problemDescription, setProblemDescription] = useState("");
  const [studentName, setStudentName] = useState("");
  const [studentGender, setStudentGender] = useState("");
  const [studentAge, setStudentAge] = useState("");
  const [addedStudents, setAddedStudents] = useState([]);
  const [followUpDescription, setFollowUpDescription] = useState("");
  const [procedureDescription, setProcedureDescription] = useState("");

  const [placeStateList, setplaceStateList] = useState([]);
  const [placeCityList, setPlaceCityList] = useState([]);

  const form = useRef();
  const studentNameRef = useRef();
  const genderMaleRef = useRef();
  const genderFemaleRef = useRef();
  const studentAgeRef = useRef();
  const procedureDescriptionRef = useRef();
  const followUpDescriptionRef = useRef();

  const apiUrl =
    process.env.NODE_ENV === "production"
      ? "https://meus-primeiros-socorros-api.vercel.app"
      : "http://localhost:3001";

  window.onbeforeunload = function () {
    return "Deseja realmente sair? Todas as informações serão perdidas!";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (addedStudents.length > 0) {
        // await fetch(`${apiUrl}/api/accidents`, {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({
        //     occurrenceDate,
        //     occurrenceTime,
        //     placeState,
        //     placeCity,
        //     schoolName,
        //     schoolType,
        //     problemType,
        //     problemPlace,
        //     problemDescription,
        //     addedStudents,
        //   }),
        // });

        const formData = {
          occurrenceDate,
          occurrenceTime,
          placeState,
          placeCity,
          schoolName,
          schoolType,
          problemType,
          problemPlace,
          problemDescription,
          addedStudents,
        };

        const response = await axios.post(`${apiUrl}/api/accidents`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 201) {
          alert("Acidente cadastrado com sucesso!");
          handleReset();

          // ... send email using emailjs ...
          /*emailjs
        .sendForm(
          "service_hx0ea87",
          "template_cxa1ldc",
          form.current,
          "kQJY04WAXDsGsnoTA"
        )
        .then(
          (result) => {
            console.log(result);
          },
          (error) => {
            console.log(error);
          }
        );*/
        }
      } else {
        alert("Nenhuma criança adicionada neste acidente!");
      }
    } catch (error) {
      console.error(error);
      alert("Ocorreu um erro ao enviar o formulário! Contate o administrador.");
    }
  };

  const handleReset = () => {
    setOccurrenceDate("");
    setOccurrenceTime("");
    setPlaceState("");
    setPlaceCity("");
    setSchoolName("");
    setSchoolType("");
    setProblemType("");
    setProblemPlace("");
    setProblemDescription("");
    setAddedStudents([]);

    handleResetStudent();
  };

  const handleResetStudent = () => {
    setStudentName("");
    setStudentGender("");
    setStudentAge("");
    setFollowUpDescription("");
    setProcedureDescription("");

    genderMaleRef.current.checked = false;
    genderFemaleRef.current.checked = false;
  };

  const handleAddStudent = (event) => {
    event.preventDefault();

    if (studentName === "") {
      studentNameRef.current.focus();
      return;
    } else if (studentAge === "") {
      studentAgeRef.current.focus();
      return;
    } else if (followUpDescription === "") {
      followUpDescriptionRef.current.focus();
      return;
    } else if (procedureDescription === "") {
      procedureDescriptionRef.current.focus();
      return;
    }

    const student = {
      name: studentName,
      gender: studentGender,
      age: studentAge,
      followUpDescription: followUpDescription,
      procedureDescription: procedureDescription,
    };

    addedStudents.push(student);
    setAddedStudents(addedStudents);
    handleResetStudent();
  };

  // fetch states
  useEffect(() => {
    if (i18n.language === languageEnum.PT) {
      setplaceStateList(statesPortuguese);
    } else {
      fetch(`${apiUrl}/api/states`)
        .then(async (response) => {
          const json = await response.json();
          return json;
        })
        .then((data) => {
          setplaceStateList(data);
        })
        .catch((error) => console.error(error));
    }
  }, [i18n.language]);

  // fetch cities
  useEffect(() => {
    if (i18n.language === languageEnum.PT) {
      setPlaceCityList(citiesPortuguese);
    } else {
      let cities = [];
      if (placeState) {
        const selectedState = placeStateList.find((state) => state.name === placeState);
        if (selectedState) {
          cities = selectedState.cities;
        }
      }
      setPlaceCityList(cities);
    }
  }, [i18n.language, placeState]);

  return (
    <div className="container  py-5" style={{ background: "rgba(106, 36, 129, 0.10)" }}>
      <main>
        <div className="pb-4 text-center">
          <span
            style={{
              color: "#6A2481",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "normal",
            }}
          >
            {t("accident.registreAquiAcidente")}
          </span>
        </div>

        <form ref={form} onSubmit={handleSubmit}>
          <div className="row g-3">
            {/* Data da Ocorrência */}
            <div className="col-sm-6">
              <input
                type="text"
                onFocus={(e) => (e.currentTarget.type = "date")}
                className="form-control"
                id="occurrenceDate"
                name="occurrenceDate"
                value={occurrenceDate}
                onChange={(event) => setOccurrenceDate(event.target.value)}
                placeholder={t("accident.dataDaOcorrencia")}
                required
              ></input>
              <div className="invalid-feedback">{t("accident.dataDaOcorrenciaObrigatorio")}</div>
            </div>

            <div className="col-sm-6">
              {/* Horário da ocorrência */}
              <input
                type="text"
                onFocus={(e) => (e.currentTarget.type = "time")}
                className="form-control"
                id="occurrenceTime"
                name="occurrenceTime"
                value={occurrenceTime}
                onChange={(event) => setOccurrenceTime(event.target.value)}
                placeholder={t("accident.horarioDaOcorrencia")}
                required
              ></input>
              <div className="invalid-feedback">{t("accident.horarioDaOcorrenciaObrigatorio")}</div>
            </div>
          </div>

          <div className="row g-3 my-1">
            {/* Estado */}
            <div className="col-sm-6">
              {/* <input
                type="text"
                className="form-control"
                id="placeState"
                name="placeState"
                value={placeState}
                onChange={(event) => setPlaceState(event.target.value)}
                placeholder="Estado"
                required
              ></input> */}
              <select
                className="form-select"
                id="placeState"
                name="placeState"
                onChange={(event) => setPlaceState(event.target.value)}
                required
              >
                <option value="">{t("accident.estado")}</option>
                {placeStateList &&
                  placeStateList.map((state, index) => (
                    <option key={index ?? state._id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
              </select>
              <div className="invalid-feedback">{t("accident.estadoObrigatorio")}</div>
            </div>

            {/* Cidade */}
            <div className="col-sm-6">
              {/* <input
                type="text"
                className="form-control"
                id="placeCity"
                name="placeCity"
                value={placeCity}
                onChange={(event) => setPlaceCity(event.target.value)}
                placeholder="Cidade"
                required
              ></input> */}
              <select
                className="form-select"
                id="placeCity"
                name="placeCity"
                onChange={(event) => setPlaceCity(event.target.value)}
                required
              >
                <option value="">{t("accident.cidade")}</option>
                {placeCityList &&
                  placeCityList.map((city, index) => (
                    <option key={index} value={city?.city ?? city}>
                      {city?.city ?? city}
                    </option>
                  ))}
              </select>
              <div className="invalid-feedback">{t("accident.cidadeEObrigatorio")}</div>
            </div>
          </div>

          {/* Nome da escola */}
          <div className="row g-3 my-1">
            <div className="col-sm-12">
              <input
                type="text"
                className="form-control"
                id="schoolName"
                name="schoolName"
                value={schoolName}
                onChange={(event) => setSchoolName(event.target.value)}
                placeholder={t("accident.nomeDaEscola")}
                required
              ></input>
              <div className="invalid-feedback">{t("accident.nomeDaEscolaObrigatorio")}</div>
            </div>
          </div>

          {/* Tipo de instituição */}
          <div className="row g-3 my-1">
            <div className="col-sm-12">
              {/* <input
                type="text"
                className="form-control"
                id="schoolType"
                name="schoolType"
                value={schoolType}
                onChange={(event) => setSchoolType(event.target.value)}
                placeholder="Tipo de instituição"
                required
              ></input> */}
              <select
                className="form-select"
                id="schoolType"
                name="schoolType"
                value={schoolType}
                onChange={(event) => setSchoolType(event.target.value)}
                placeholder={t("accident.tipoDeInstituicao")}
                required
              >
                <option value="">{t("accident.tipoDeInstituicao")}</option>
                <option value="1">{t("accident.tipoDeInstituicaoPublica")}</option>
                <option value="2">{t("accident.tipoDeInstituicaoPrivada")}</option>
              </select>
              <div className="invalid-feedback">{t("accident.tipoDeInstituicaoObrigatorio")}</div>
            </div>
          </div>

          {/* Tipo de Acidente */}
          <div className="row g-3 my-1">
            <div className="col-sm-12">
              {/* <input
                type="text"
                className="form-control"
                id="problemType"
                name="problemType"
                value={problemType}
                onChange={(event) => setProblemType(event.target.value)}
                placeholder="Tipo de acidente"
                required
              ></input> */}
              <select
                className="form-select"
                id="problemType"
                name="problemType"
                value={problemType}
                onChange={(event) => setProblemType(event.target.value)}
                placeholder={t("accident.tipoDeAcidente")}
                required
              >
                <option value="" selected>
                  {t("accident.tipoDeAcidente")}
                </option>
                <option value="1">{t("accident.paradaCardiorrespiratoria")}</option>
                <option value="2">{t("accident.engasgo")}</option>
                <option value="3">{t("accident.afogamento")}</option>
                <option value="4">{t("accident.criseConvulsiva")}</option>
                <option value="5">{t("accident.desmaio")}</option>
                <option value="6">{t("accident.queda")}</option>
                <option value="7">{t("accident.colisaoComOutraPessoa")}</option>
                <option value="8">{t("accident.colisaoComObjeto")}</option>
                <option value="9">{t("accident.lesaoObjetosCortantes")}</option>
                <option value="10">{t("accident.contatoSubstanciaQuenteToxica")}</option>
                <option value="11">{t("accident.outro1")}</option>
              </select>
              <div className="invalid-feedback">{t("accident.tipoDeAcidenteObrigatorio")}</div>
            </div>
          </div>

          {/* Local do Acidente */}
          <div className="row g-3 my-1">
            <div className="col-sm-12">
              {/* <input
                type="text"
                className="form-control"
                id="problemPlace"
                name="problemPlace"
                value={problemPlace}
                onChange={(event) => setProblemPlace(event.target.value)}
                placeholder="Local do acidente"
                required */}
              <select
                className="form-select"
                id="problemPlace"
                name="problemPlace"
                value={problemPlace}
                onChange={(event) => setProblemPlace(event.target.value)}
                placeholder={t("accident.localDoAcidente")}
                required
              >
                <option value="" selected>
                  {t("accident.localDoAcidente")}
                </option>
                <option value="1">{t("accident.salaDeAula")}</option>
                <option value="2">{t("accident.corredor")}</option>
                <option value="3">{t("accident.auditorio")}</option>
                <option value="4">{t("accident.patio")}</option>
                <option value="5">{t("accident.parque")}</option>
                <option value="6">{t("accident.quadraEsportiva")}</option>
                <option value="7">{t("accident.refeitorio")}</option>
                <option value="8">{t("accident.estacionamento")}</option>
                <option value="9">{t("accident.escada")}</option>
                <option value="10">{t("accident.banheiro")}</option>
                <option value="11">{t("accident.outro2")}</option>
              </select>
              <div className="invalid-feedback">{t("accident.localDoAcidenteObrigatorio")}</div>
            </div>
          </div>

          {/* Breve relato do acidente */}
          <div className="row g-3 my-1">
            <div className="col-md-12">
              <label htmlFor="problemDescription" className="form-label mx-2">
                {t("accident.breveRelatoDoAcidente")}
              </label>
              <div className="form-floating">
                <textarea
                  className="form-control"
                  id="problemDescription"
                  name="problemDescription"
                  value={problemDescription}
                  onChange={(event) => setProblemDescription(event.target.value)}
                  style={{ height: "100px" }}
                  required
                ></textarea>
              </div>
              <div className="invalid-feedback">{t("accident.breveRelatoObrigatorio")}</div>
            </div>
          </div>

          {/* Adicionar criança */}
          <div className="row g-1 my-3">
            <div
              className="col-md-12 text-center"
              style={{
                background: "#6A2481",
                borderRadius: "8px",
                color: "#FFF",
                height: "40px",
              }}
            >
              <span style={{ verticalAlign: "sub" }}>
                {t("accident.adicionarCrianca")} <i className="bi bi-person-square"></i>
              </span>
            </div>
          </div>

          <div
            className="row g-2 m-1 p-1"
            style={{
              borderRadius: "8px",
              border: "1px solid rgba(106, 36, 129, 0.25)",
              background: "#E9EBEF",
            }}
          >
            {/* Nome da criança */}
            <div className="col-sm-12">
              <div className="row g-3">
                <div className="col-sm-12">
                  <label htmlFor="student" className="form-label">
                    {t("accident.nomeDaCrianca")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="studentName"
                    name="studentName"
                    value={studentName}
                    onChange={(event) => setStudentName(event.target.value)}
                    ref={studentNameRef}
                    //required
                  ></input>
                  <div className="invalid-feedback">{t("accident.nomeDaCriancaObrigatorio")}</div>
                </div>
              </div>

              {/* Sexo & Idade*/}
              <div className="row g-3 mt-1">
                <div className="col-sm-12">
                  <input
                    type="radio"
                    id="gender"
                    name="gender"
                    value="Masculino"
                    onClick={(event) => setStudentGender(event.target.value)}
                    ref={genderMaleRef}
                    //required
                  ></input>
                  <label htmlFor="gender">&nbsp;{t("accident.masculino")}</label>&nbsp;
                  <input
                    type="radio"
                    id="gender"
                    name="gender"
                    value="Feminino"
                    onClick={(event) => setStudentGender(event.target.value)}
                    ref={genderFemaleRef}
                    //required
                  ></input>
                  <label htmlFor="gender">&nbsp;{t("accident.feminino")}</label>
                  <input
                    type="number"
                    min="4"
                    max="10"
                    className="form-control"
                    id="studentAge"
                    name="studentAge"
                    style={{ width: "20%", float: "right" }}
                    placeholder={t("accident.idade")}
                    value={studentAge}
                    onChange={(event) => setStudentAge(event.target.value)}
                    ref={studentAgeRef}
                    //required
                  ></input>
                  <div className="invalid-feedback">{t("accident.idadeObrigatorio")}</div>
                </div>
              </div>

              {/* Encaminhamento da Criança */}
              <div className="row g-3 mt-1">
                <div className="col-md-12">
                  {/* <label htmlFor="followUpDescription" className="form-label">
                    Encaminhamento da criança
                  </label>
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      id="followUpDescription"
                      name="followUpDescription"
                      value={followUpDescription}
                      onChange={(event) =>
                        setFollowUpDescription(event.target.value)
                      }
                      style={{ height: "100px" }}
                      ref={followUpDescriptionRef}
                      //required
                    ></textarea>
                  </div> */}
                  <select
                    className="form-select"
                    id="followUpDescription"
                    name="followUpDescription"
                    value={followUpDescription}
                    onChange={(event) => setFollowUpDescription(event.target.value)}
                    placeholder="Encaminhamento da criança"
                    required
                  >
                    <option value="" selected>
                      {t("accident.encaminhamentoCrianca")}
                    </option>
                    <option value="1">{t("accident.encaminhamentoCriancaParagrafo1")}</option>
                    <option value="2">{t("accident.encaminhamentoCriancaParagrafo2")}</option>
                    <option value="3">{t("accident.encaminhamentoCriancaParagrafo3")}</option>
                    <option value="4">{t("accident.encaminhamentoCriancaParagrafo4")}</option>
                  </select>
                  <div className="invalid-feedback">{t("accident.encaminhamentoObrigatorio")}</div>
                </div>
              </div>

              {/* Conduta Realizada */}
              <div className="row g-3 mt-1">
                <div className="col-md-12">
                  <label htmlFor="procedureDescription" className="form-label">
                    {t("accident.condutasRealizadas")}
                  </label>
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      id="procedureDescription"
                      name="procedureDescription"
                      value={procedureDescription}
                      onChange={(event) => setProcedureDescription(event.target.value)}
                      style={{ height: "100px" }}
                      ref={procedureDescriptionRef}
                      //required
                    ></textarea>
                  </div>
                  <div className="invalid-feedback">{t("accident.condutaObrigatorio")}</div>
                </div>
              </div>

              {/* Adicionar Criança */}
              <div className="row g-1 my-1">
                <div className="col-sm-12">
                  <button
                    type="button"
                    onClick={handleAddStudent}
                    //onClick={() => props.notify}
                    className="btn btn-warning"
                    style={{
                      float: "right",
                      background: "#6A2481",
                      color: "#FFF",
                      border: "1px solid rgba(106, 36, 129, 0.25)",
                    }}
                  >
                    {t("accident.ok")}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Lista de alunos inseridos */}
          <div className="row g-3 mt-1">
            <div className="col-md-12">
              <AddedStudentsList addedStudents={addedStudents} />
            </div>
          </div>

          <button
            className="w-100 btn btn-lg my-2"
            type="submit"
            style={{
              width: "264px",
              height: "40px",
              flexShrink: "0",
              borderRadius: "8px",
              background: "#6A2481",
              boxShadow: "0px 4px 8px 0px #6A2481",
              color: "#FFF",
              fontFamily: "Poppins",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "normal",
            }}
          >
            <i className="bi bi-bandaid"></i> {t("accident.salvarEsteAcidente")}
          </button>
        </form>
      </main>
    </div>
  );
}
